/* Pulsante «Iscriviti» del footer → popup opt-in v2 di Klaviyo (issue #624,
 * approvato da Matteo il 30/09/2026, ordine della regia del 01/10/2026).
 *
 * Il pulsante è un link vero alla pagina di riserva /pages/newsletter (stessa
 * lista del popup per lingua). Con JS attivo il click apre il popup della
 * lingua con l'API ufficiale Klaviyo `_klOnsite.push(['openForm', id])` (doc
 * «Custom trigger a popup or flyout form», developers.klaviyo.com, letta il
 * 01/10/2026: il trigger personalizzato scavalca il targeting del form).
 *
 * Comportamento del klaviyo.js live verificato nel collaudo del 01/10/2026:
 * - `_klOnsite.openForm` vuole argomenti separati (id, callback), non l'array
 *   della documentazione → si usa sempre la coda `push`;
 * - la callback di openForm scatta anche quando il popup NON si apre (es.
 *   desktop, popup chiuso con la X nella stessa pagina) → l'apertura si
 *   conferma SOLO con l'evento documentato `klaviyoForms` di tipo «open»;
 * - dopo la X su desktop il popup non si riapre nella stessa pagina, ma si
 *   riapre in una pagina nuova → un solo ricaricamento con richiesta di
 *   apertura in sessionStorage, e il popup si apre al caricamento.
 *
 * Paracadute: klaviyo.js assente o bloccato (consenso negato, ad-block) o
 * nessuna conferma nemmeno dopo il ricaricamento → pagina di riserva.
 * Mai un click a vuoto.
 */
(function () {
  'use strict';

  var ATTESA_MS = 2500;          // klaviyo.js non (ancora) pronto al click
  var ATTESA_PRONTO_MS = 1500;   // klaviyo.js pronto: il popup si apre in < 1 s
  var ATTESA_RICARICA_MS = 6000; // dopo il ricaricamento klaviyo.js arriva tardi
  var CHIAVE = 'vietti_newsletter_apri';

  function sessione() {
    try { return window.sessionStorage || null; } catch (err) { return null; }
  }

  function klaviyoPronto() {
    var kl = window._klOnsite;
    return !!(kl && (kl._loaded || typeof kl.openForm === 'function'));
  }

  function tenta(formId, riserva, puoRicaricare, attesa, link) {
    var confermato = false;
    var timer;

    function ascolta(e) {
      var d = e && e.detail;
      if (d && d.type === 'open' && d.formId === formId) {
        confermato = true;
        chiudi();
      }
    }

    function chiudi() {
      window.clearTimeout(timer);
      if (link) link.removeAttribute('aria-busy');
      if (window.removeEventListener) window.removeEventListener('klaviyoForms', ascolta);
    }

    function nessunaConferma() {
      chiudi();
      if (confermato) return;
      var s = sessione();
      if (puoRicaricare && klaviyoPronto() && s) {
        s.setItem(CHIAVE, formId);
        window.location.reload();
      } else {
        window.location.assign(riserva);
      }
    }

    window.addEventListener('klaviyoForms', ascolta);
    if (link) link.setAttribute('aria-busy', 'true');
    timer = window.setTimeout(nessunaConferma, attesa);

    try {
      var kl = window._klOnsite = window._klOnsite || [];
      kl.push(['openForm', formId]);
    } catch (err) {
      puoRicaricare = false;
      nessunaConferma();
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('[data-newsletter-trigger]') : null;
    if (!link) return;
    var formId = link.getAttribute('data-klaviyo-form');
    var riserva = link.getAttribute('href');
    if (!formId || !riserva) return; // senza ID: il link segue l'href
    event.preventDefault();
    tenta(formId, riserva, true, klaviyoPronto() ? ATTESA_PRONTO_MS : ATTESA_MS, link);
  });

  // Richiesta di apertura lasciata dal click prima del ricaricamento.
  var s = sessione();
  var richiesto = s && s.getItem(CHIAVE);
  if (richiesto) s.removeItem(CHIAVE);
  if (richiesto && /^[A-Za-z0-9]+$/.test(richiesto)) {
    var link = document.querySelector('[data-newsletter-trigger][data-klaviyo-form="' + richiesto + '"]');
    var riserva = link && link.getAttribute('href');
    if (riserva) tenta(richiesto, riserva, false, ATTESA_RICARICA_MS, link);
  }
})();
